export var PaymentHistoryItemStatus;
(function (PaymentHistoryItemStatus) {
    PaymentHistoryItemStatus["Failed"] = "failed";
    PaymentHistoryItemStatus["Succeeded"] = "succeeded";
    PaymentHistoryItemStatus["Pending"] = "pending";
    PaymentHistoryItemStatus["Refunded"] = "refunded";
})(PaymentHistoryItemStatus || (PaymentHistoryItemStatus = {}));
export const KEEP_PAYMENT_METHODS_MODAL_OPEN = 'keepPaymentMethodsModalOpen';
//# sourceMappingURL=billing.js.map